<div (click)="this.copyContent()">
  <cam-font-icon name="copy" type="xs"></cam-font-icon>
</div>
